export enum Routes {
  dashboard = '/dashboard',
  provisioningRequest = '/provisioning-requests',
  simInventory = '/sim-inventory',
  admin = '/admin',
  customFields = '/admin/custom-fields',
  rsimManufacturingFile = '/admin/rsim-manufacturing-file',
  auditTrail = '/audit-trail',
  products = '/products',
  productsSim = '/products/sim',
  productsRsim = '/products/rsim',
  tariffSummary = '/products/tariff-summary',
  productSummary = '/products/product-summary',
  esim = '/products/esim',
  locations = '/locations',
  activityLog = '/activity-log',
  simProvisioning = '/activity-log/sim-provisioning',
  productsManagement = '/activity-log/products-management',
  subscriptionStatusReconciliation = '/admin/subscription-status-reconciliation',
}
